/* ナマエノアトリエ: お名前・字体なしの注文を防ぐガード
   1) 分割払い表示用フォームの誤送信防止（2026-08-08）
   2) お名前入力欄（Globo）の読み込み前に「カートに追加」されるのを防止（2026-10-10 注文16614の再発防止） */
(function () {
  function guard(form) {
    if (!form || form.__nmaGuarded) return;
    form.__nmaGuarded = true;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }, true);
  }
  function scan() {
    var forms = document.querySelectorAll('form.installment[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) guard(forms[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  try {
    new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  } catch (err) {}

  // ---- 2) お名前入力欄の読み込み待ち ----
  var path = location.pathname.replace(/\/$/, '');
  if (!/\/products\/[^\/]+$/.test(path)) return;
  // null=確認中 / true=お名前が必要な商品 / false=不要
  var nameRequired = null;
  try {
    fetch(path + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var tags = (p && p.tags) || [];
        nameRequired = tags.indexOf('お名前シール') >= 0;
      })
      .catch(function () { nameRequired = true; });
  } catch (err) { nameRequired = true; }

  function showMsg(form, text) {
    var el = document.getElementById('nma-name-wait');
    if (!el) {
      el = document.createElement('p');
      el.id = 'nma-name-wait';
      el.setAttribute('role', 'alert');
      el.style.cssText = 'color:#b42318;font-size:14px;font-weight:bold;margin:8px 0;';
      var btn = form.querySelector('[type="submit"],[name="add"]');
      (btn && btn.parentNode ? btn.parentNode : form).insertBefore(el, btn || null);
    }
    el.textContent = text;
    try { el.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (err) {}
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (form.classList.contains('installment')) return;
    if (nameRequired === false) return;
    // Globoのお名前入力欄が組み込まれていれば、入力チェックはGlobo側に任せる
    if (form.querySelector('[name="properties[_has_gpo]"]')) {
      var old = document.getElementById('nma-name-wait');
      if (old) old.remove();
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
    showMsg(form, 'お名前の入力欄を読み込み中です。数秒待ってから、お名前を入れてもう一度押してください。表示されない場合はページを再読み込みしてください。');
  }, true);
})();
